export const state = {
  user: {},
  notExistsEmail: null,
  isUserMetadataLoading: false,
  lastLoggedIn: undefined,
};
